import { render, staticRenderFns } from "./SlimLayout.vue?vue&type=template&id=4de2ae3c&"
import script from "./SlimLayout.vue?vue&type=script&lang=js&"
export * from "./SlimLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports